//famous.js
import request from '@/utils/request';

export function getFamous(forum_id) {
  return request({
    url: '/v1/forum_info/' + forum_id + '/forum_famous_scholar',
    method: 'get',
  });
}
